import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'
import cryp from '../util/CriptografiaAES'
const BASE_URL = util.API_URL;

const INITIAL_VALUES = {
    desativaPercentualDesconto: true, desativaValorDesconto: true
}

export function getList(tipo = "", valor = "", unidades, offset = 0, limit = 15) {
    const request = axios.get(`${BASE_URL}/unidades`, {
        headers: {
            tipo,
            valor,
            offset,
            limit,
            unidades
        }
    })
    return {
        type: 'UNIDADE_FETCHED',
        payload: request
    }
}

export function create(values) {
    try {
        if (values.certificado != null) {
            values.certificado = cryp.encryptData(values.certificado);
        }
        if (values.key_certificado != null) {
            values.key_certificado = cryp.encryptData(values.key_certificado);
        }
    } catch (ex) {
        values.certificado = null;
        values.key_certificado = null;
        console.log('erro ao criptografar certificado e key')
    }
    return submit(values, 'post')
}

export function update(values) {
    try {
        if (values.certificado != null) {
            values.certificado = cryp.encryptData(values.certificado);
        }
        if (values.key_certificado != null) {
            values.key_certificado = cryp.encryptData(values.key_certificado);
        }
    } catch (ex) {
        values.certificado = null;
        values.key_certificado = null;
        console.log('erro ao criptografar certificado e key')
    }
    return submit(values, 'put')
}

export function remove(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/unidades/delete`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

function submit(values, method) {
    return dispatch => {
        axios[method](`${BASE_URL}/unidades`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function showUpdate(unidade) {
    try {
        if (unidade.certificado != null) {
            unidade.certificado = cryp.DencryptData(unidade.certificado);
        }
        if (unidade.key_certificado != null) {
            unidade.key_certificado = cryp.DencryptData(unidade.key_certificado);
        }
    } catch (ex) {
        unidade.certificado = null;
        unidade.key_certificado = null;
        console.log('erro ao descriptografar certificado e key')
    }
    return [
        showTabs('tabUpdate'),
        selectTab('tabUpdate'),
        initialize('unidadeForm', unidade)
    ]
}

/* TODO refatorar para utilizar um metodo so com o showupdate*/
export function showDelete(unidade) {
    return [
        showTabs('tabDelete'),
        selectTab('tabDelete'),
        initialize('unidadeForm', unidade)
    ]
}

export function init() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        initialize('unidadeForm', INITIAL_VALUES)
    ]
}



// WEBPACK FOOTER //
// ./src/unidade/unidadeAction.js